import React from 'react'
import { TidewaysContext } from '../app/context'
import Router from '../router'
import BeforeAfterProjectLimitsSection from './BeforeAfterProjectLimitsSection'
import ChangePaymentInterval from './ChangePaymentInterval'
import { PaymentInterval, PaymentIntervalType } from './Recurly'
import ReviewTeams from './ReviewTeams'
import SelectTideways6Plans from './SelectTideways6Plans'
import SelectTideways8Plans from './SelectTideways8Plans'
import Summary from './Summary'
import { UpgradeTideways6 } from './UpgradeTideways6'

interface Props {
    recurlyPricing: any
    upgrade: UpgradeTideways6
    actionUrl: string
    csrfToken: string
    tidewaysContext?: TidewaysContext
    router?: Router
}
interface State {
    projectSizes: { [key: string]: number }
    newPlan: string
    requests: number
    teams: number
    currency: string
    coupon: string
    interval: PaymentInterval
}

class StartCheckout extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            projectSizes: this.props.upgrade.projectSizes,
            newPlan: this.props.upgrade.newPlan.replace('_1y', ''),
            requests: this.props.upgrade.startRequests,
            currency: this.props.upgrade.currency,
            coupon: this.props.upgrade.coupon,
            interval: this.props.upgrade.newPlan.indexOf('_1y') > 0 ? PaymentInterval.Yearly : PaymentInterval.Monthly,
            teams: this.props.upgrade.teamsCount,
        }
    }

    public render() {
        const currencies = [
            { code: 'EUR', name: 'Euro' },
            { code: 'USD', name: 'US Dollar' },
        ]

        const yearlySavings = ''
        const projectSizes = {}
        this.props.upgrade.applications.forEach(application => {
            projectSizes[application.id] = application.projectSize
        })

        // https://app.tideways.local/settings/organizations/qafoo/billing/change-project-size/mabilis
        const changeProjectSizeBaseUrl = this.props.actionUrl.replace('/checkout/start', '/billing/change-project-size')
        const removeProjectUrlPattern = this.props.actionUrl
            .replace('/checkout/start', '/{projectName}/remove')
            .replace('/settings/organizations', '/o')

        const newPlan = this.state.interval == PaymentInterval.Yearly ? this.state.newPlan + '_1y' : this.state.newPlan
        const paymentIntervalType = this.state.newPlan.startsWith('tideways8')
            ? PaymentIntervalType.TEN_PERCENT
            : PaymentIntervalType.ELEVEN_FOR_TWELVE

        return (
            <form method="POST" action={this.props.actionUrl} style={{ fontSize: '12pt' }}>
                <input type="hidden" name="_csrf[billing]" value={this.props.csrfToken} />
                <input type="hidden" name="checkout[plan]" value={newPlan} />
                <input type="hidden" name="checkout[requests]" value={this.state.requests} />
                <input type="hidden" name="checkout[currency]" value={this.state.currency} />
                <input type="hidden" name="checkout[coupon]" value={this.state.coupon} />
                <input type="hidden" name="checkout[teams]" value={this.state.teams} />
                <h3 style={{ marginTop: '0px' }}>Select Plan</h3>
                {this.props.upgrade.newPlan.startsWith('tideways8') ? (
                    <SelectTideways8Plans
                        recurlyPricing={this.props.recurlyPricing}
                        upgrade={this.props.upgrade}
                        onPlanChange={plan => this.setState({ newPlan: plan })}
                        onRequestsChange={requests => this.setState({ requests: requests })}
                        selectedPlan={this.state.newPlan}
                        interval={this.state.interval}
                        currency={this.state.currency}
                        tidewaysContext={this.props.tidewaysContext}
                        router={this.props.router}
                    />
                ) : (
                    <SelectTideways6Plans
                        recurlyPricing={this.props.recurlyPricing}
                        upgrade={this.props.upgrade}
                        onPlanChange={plan => this.setState({ newPlan: plan })}
                        selectedPlan={this.state.newPlan}
                        interval={this.state.interval}
                        currency={this.state.currency}
                    />
                )}
                {this.renderReviewProjects(changeProjectSizeBaseUrl, removeProjectUrlPattern)}
                <ReviewTeams
                    upgrade={this.props.upgrade}
                    actionUrl={this.props.actionUrl}
                    onTeamsChange={teams => this.setState({ teams })}
                    newPlan={this.state.newPlan}
                />

                <div className="row">
                    <div className="col-md-6">
                        <h3>How often do you want to be billed?</h3>

                        <ChangePaymentInterval
                            type={paymentIntervalType}
                            interval={this.state.interval}
                            callback={interval => this.setState({ interval })}
                        />
                    </div>

                    <div className="col-md-6">
                        <h3>What Currency do you want to pay in?</h3>

                        <div className="box">
                            <div className="box-body">
                                <div className="row form-inline" style={{ marginBottom: '20px' }}>
                                    {currencies.map(currency => {
                                        return (
                                            <div key={currency.code} className="col-lg-3">
                                                <input
                                                    id={'currency-' + currency.code}
                                                    type="radio"
                                                    className="radio"
                                                    value={currency.code}
                                                    checked={currency.code === this.state.currency}
                                                    onChange={event => this.setState({ currency: event.target.value })}
                                                />
                                                <label htmlFor={'currency-' + currency.code}>{currency.name}</label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3>Summary</h3>
                <Summary
                    recurlyPricing={this.props.recurlyPricing}
                    upgrade={this.props.upgrade}
                    newPlan={this.state.newPlan}
                    requests={this.state.requests}
                    teams={this.state.teams}
                    coupon={this.state.coupon}
                    currency={this.state.currency}
                    projectSizes={projectSizes}
                    interval={this.state.interval}
                />
                <div style={{ textAlign: 'center' }}>
                    <button className="btn btn-primary btn-lg" id="signup" type="submit">
                        Confirm and choose Payment Method
                    </button>
                </div>
            </form>
        )
    }

    private renderReviewProjects(changeProjectSizeBaseUrl: string, removeProjectUrlPattern: string) {
        if (this.state.newPlan.startsWith('tideways8')) {
            return null
        }

        return (
            <>
                <h4>Review Project Sizes</h4>
                <div className="box">
                    <div className="box-body no-padding">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th style={{ width: '30%' }}>Project Name</th>
                                    <th>Project Size</th>
                                    <th>Used and Available Limits for the Project Size</th>
                                    <th>Options</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.upgrade.applications.map(application => {
                                    return (
                                        <tr key={application.id}>
                                            <td>{application.name}</td>
                                            <td width="7%">{application.projectSize}</td>
                                            <td width="25%">
                                                <BeforeAfterProjectLimitsSection
                                                    onlyAfter={true}
                                                    upgrade={this.props.upgrade}
                                                    projectId={application.id.toString()}
                                                    projectSize={application.projectSize}
                                                    plan={this.state.newPlan}
                                                />
                                            </td>
                                            <td width="10%">
                                                <a
                                                    className="btn btn-xs btn-default"
                                                    href={
                                                        changeProjectSizeBaseUrl +
                                                        '/' +
                                                        encodeURIComponent(application.name) +
                                                        '?checkout=1'
                                                    }
                                                >
                                                    Change
                                                </a>
                                                <a
                                                    className="btn btn-xs btn-default"
                                                    href={
                                                        removeProjectUrlPattern.replace(
                                                            '{projectName}',
                                                            encodeURIComponent(application.name),
                                                        ) + '?checkout=1'
                                                    }
                                                >
                                                    Remove
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
}

export default StartCheckout
